module.exports = "/images/projects-black.svg?18ecb34c2f787adf5c69e38d7feebd92";